import React, {useState,useEffect,useRef} from 'react';
import { apiEndpoint } from "helpers/url_helper";

//import React from "react";
import ReactDOM from "react-dom";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HC_more from 'highcharts/highcharts-more'
import highcharts3d from 'highcharts/highcharts-3d'
// import Drilldown from 'highcharts/drilldown'
import drilldown from 'highcharts/modules/drilldown.js';
//import './PieChart.css'

import {series,drilldownSeries} from './BrowserData'
import _ from "lodash";
var tinycolor = require("tinycolor2");
const Color = require('color');
HC_more(Highcharts)
highcharts3d(Highcharts)
drilldown(Highcharts)



function PieChart(props) {
console.log(props.props)
	let chart = null;

  
  var offset = 180;



 
  const [angle, setAngle] = useState(offset);
  const [level, setLevel] = useState(0);
  const [data,setData]=useState([]);
  //const [angle, setAngle] = useState(angleMap.IE);

  //testing:
  console.log("op",series[0].options);
  //series[0].options = level;


  var exampleColors = ["rgb(15,72,127)", "rgb(52,109,164)", "rgb(88,145,200)", "rgb(124,181,236)", "rgb(160,217,255)", "rgb(196,253,255)", "rgb(233,255,255)", "rgb(255,255,255)", "rgb(255,255,255)", "rgb(255,255,255)"]
  var sample_options = {
    credits: {enabled: false},
    chart: {
        type: 'pie',
         backgroundColor: 'rgba(0,0,0,0)',
        //backgroundColor: 'black',
        margin: [0,0,0,15],
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0,
        options3d: {
            enabled: true,
            alpha: 75,
            beta: 0
        }
    },
    title: {text: undefined},
    credits: {
        enabled: false
    },

    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
        pie: {
            allowPointSelect: false,
            slicedOffset: 40,
			// todo: don't think I'm seeing this shadow here
			shadow:true,
            startAngle:angle,
            cursor: 'pointer',
            depth: 55,
            size: '120%',
            colors:exampleColors,
            // testing: not available in 3d = edge (but doesn't extend down sides :/)
            //edgeColor:"black",
            //edgeWidth:.5,
            borderColor: '#000000',
            color: '#000000',
            innerSize:155,
            depth: 45,
            dataLabels: {
                enabled: true,
                color: 'black',
                fontSize:"x-large"
              },
            //note: must be here in order to show up even with legend enabled
            //showInLegend: true
            
            //note: lot of options here, don't understand this versus series dataLabels
            //dataLabels:''
           
        
		},
		series: {
            //required to drilldown
            allowPointSelect: true,
             dataLabels: {
                enabled: false,
                //distance:-30,
                format: '{point.name}'
            },
            point: {
                events: {
                   
                    select: function(selected) {
                        var points = this.series.points;
                        console.log("selected",selected.target);
                        points.forEach(p =>{
                          //  console.log(p);
                        p.category = p.color
                        // p.id !== selected.target.id ? p.color = tinycolor(p.color).lighten(50).toString():{};
                        p.id !== selected.target.id ? p.color = Color(p.color).lighten(.3).alpha(.3).toString():{};
                        })
                       // console.log(points);
                    }, unselect: function(selected) {
                        console.log("unselect");
                        var points = this.series.points;
                      
                        points.forEach(p =>{
                        p.color = p.category;
                        })
                        //console.log(points);
                    }
                }
            },
        }
	},
	series: series,
	drilldown: drilldownSeries
}

	const elementRef = useRef();

	useEffect(() => {
var requestBody=props.props;
// can't change
const response =  fetch(apiEndpoint+"/GetSpeedDistributionData", 
{
      
method: 'POST',
// mode:'no-cors',
headers: {
    'Content-Type': 'application/json', 
},
body:requestBody
});
console.log(response);
if(response.body!=null && response !=undefined)
{
const data =  response.json();
var objToArr=JSON.parse( data.speed);
const newArrayOfObj = (objToArr).map(({
"Key": name,
"Value":y,
...rest
}) => ({
name,y,
...rest
}));

setData(newArrayOfObj);
this.internalChart.series[0].setData(newArrayOfObj);
		let angleMap = {
			Firefox:0 + offset,
			IE: .45 * 360 + offset
		  }
		console.log(angleMap);
 
		setTimeout(e =>{
		setAngle(angleMap['IE'])
		},2000)
  }},props.props);
  

    const drillUp = () =>{
		//console.log("chart",chart.chart.series[0]);
		//if (chart.chart.drilldownLevels.length > 0) {
			// chart.chart.drillUp();
		///}
        var locChart = elementRef.current.chart;
		console.log(locChart);
       // elementRef.current.chart.drillUp()
        setTimeout(function () {
            console.log(locChart.series[0].options);
             //nope
             //locChart.series[0].options._levelNumber = 1

             locChart.series[0].update({
               options:{_levelNumber:1}
            });
             console.log(locChart.series[0].options._levelNumber);
        }, 2000);
    }
    
    const [count, setCount] = useState(0); 
    const selectRand = () =>{

        var locChart = elementRef.current.chart;
        //https://api.highcharts.com/highcharts/series.pie.data.sliced
        locChart.series[0].data[count].slice(true)
        //locChart.series[0].data[count].select()
        setCount(prev => prev +1)
    }


	return(
		<div>
            <div >
				{/* <HighchartsReact  ref={elementRef} highcharts={Highcharts} */}
                <HighchartsReact  ref={elementRef} highcharts={Highcharts}

                  allowChartUpdate={true}
                  options={sample_options} /> 
			</div>

	</div>)

}
export default PieChart;